import { render, staticRenderFns } from "./back-top.vue?vue&type=template&id=15febc7a&scoped=true"
import script from "./back-top.vue?vue&type=script&lang=js"
export * from "./back-top.vue?vue&type=script&lang=js"
import style0 from "./back-top.vue?vue&type=style&index=0&id=15febc7a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15febc7a",
  null
  
)

export default component.exports